import * as constants from "../constants";
import * as HttpClient from "./http-client";

const initCheckout = () => {
    return new Promise((resolve, reject) => {
        const body = {
            planId: 6
        }
        const url = constants.urls.initCheckout();
        HttpClient.POST(url, JSON.stringify(body))
        .then(response => {
            response.json().then((json) => {
                var resolveData = null;

                if (response.ok) {
                    resolveData = {
                        success: true,
                        json
                    }
                }
                else {
                    resolveData = {
                        success: false,
                        json,
                    }
                }
    
                resolve(resolveData);
            })
            .catch((error) => {
                console.error('Error:', error);
                reject(error);
            })
        })
        .catch((error) => {
            console.error('Error:', error);
            reject(error);
        });
    });
}

export { initCheckout }